export default __webpack_public_path__ + "static/media/bgMobile.23472f23.png";